const COLORS = {
	dark0: '#001529',
	primary0: '#1890ff',

	success: '#52c41a',
	default: '#d9d9d9',
	processing: '#1890ff',
	error: '#ff4d4f',

	successDark: '#429d15',
	processingDark: '#1373cc',
	errorDark: '#d66565',
	warningDark: '#b6870f',

	successLight: '#aff08e',
	errorLight: '#ffb3b3',

	successUltraLight: '#cff6bb',
	errorUltraLight: '#ffe5e6',

	successUltraDark: '#194d00',
	errorUltraDark: '#800000',

	nearServiceColor: '#001529',
	vrsServiceColor: '#8113cc',

	featureStrokeColor: '#ffffff',

	pink: '#f02090',

	gray: '#999999',
	grayDark: '#666666',
}

const OPACITY = {
	full: 'ff',
	half: '99',
}

const CSS = {
	paddingMd: '16px',
}

const ROVERS_TABLE_COLUMNS = [
	{
		dataIndex: 'group_uid',
		key: 'group_uid',
	},
	{
		dataIndex: 'label',
		key: 'label',
	},
	{
		dataIndex: 'user_id',
		key: 'user_id',
	},
	{ key: 'display_status' },
	{ key: 'geo_fencing' },
	{ key: 'actions' },
	{ key: 'tariff' },
]


const ROVERS_STATS_TABLE_COLUMNS = [
	{ dataIndex: 'group_uid' },
	{ dataIndex: 'label' },
	{ dataIndex: 'user_id' },
	{ dataIndex: 'duration_online', align: 'right' },
	{ dataIndex: 'last_online_datetime', align: 'right' },
	{ dataIndex: 'added_datetime', align: 'right' },
]


const ADMIN_STATS_TABLE_COLUMNS = [
	{ dataIndex: 'group_uid' },
	{ dataIndex: 'users_count', align: 'right' },
	{ dataIndex: 'rovers_count', align: 'right' },
	{ dataIndex: 'duration_online', align: 'right' },
]


const ROVERS_TABLE_TARIFFS_COLUMNS = [
	{
		dataIndex: 'label',
		key: 'label',
	},
	{
		dataIndex: 'user_id',
		key: 'user_id',
	},
	{ key: 'tariff_current' },
	{ key: 'tariff_end_datetime' },
]


const PAYMENTS_TABLE_COLUMNS = [
	{ dataIndex: 'uuid' },
	{ dataIndex: 'group_uid' },
	{ dataIndex: 'username' },
	{ dataIndex: 'status' },
	{ dataIndex: 'amount', align: 'right' },
	{ dataIndex: 'created_at', align: 'right' },
	{ dataIndex: 'paid_at', align: 'right' },
	{ dataIndex: 'description' },
]


export default {
	COLORS,
	OPACITY,
	CSS,
	ROVERS_TABLE_COLUMNS,
	ROVERS_STATS_TABLE_COLUMNS,
	ADMIN_STATS_TABLE_COLUMNS,
	ROVERS_TABLE_TARIFFS_COLUMNS,
	PAYMENTS_TABLE_COLUMNS,
}
